// Format Bytes
export const FormatBytes = (bytes: any, decimals: number = 2) => {

    if (bytes === 0) return '0 Bytes';

    const dm = decimals < 0 ? 0 : decimals;
    const k = 1024;

    // Define Units
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    // Calculate the index of the appropriate unit
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    // Format Value
    const formattedValue = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

    // Return Data
    return formattedValue + ' ' + sizes[i];

};
